import { Alert } from "bootstrap";
import React from "react";
import { Card, Col, Jumbotron, Row } from "react-bootstrap";

export default function Home() {
  return (
    <div style={{ textAlign: "center" }}>
      <h1>Welcome to Sociable</h1>
      <h3>Get quality vetted reviews before doing influencer/brand deals</h3>
      <br></br>
      <br></br>
      <Row>
        <Col>
          <Jumbotron>
            <h3>For Brands:</h3>
            <p>
              See reviews of influencers and<br></br> the past brands they have
              done deals with
            </p>
          </Jumbotron>
        </Col>
        <Col>
          <Jumbotron>
            <h3>For Influencers:</h3>
            <p>
              Read reviews from real influencers on<br></br> the brand before
              you do the deal
            </p>
          </Jumbotron>
        </Col>
      </Row>
      <hr></hr>
      <div>
        <h3>
          <u>🕵️‍♂️ Before doing a deal:</u>
        </h3>
        <p>Check Sociable to see their previous work and reviews</p>
      </div>
      <div>
        <h3>
          <u>✍️After doing a deal:</u>
        </h3>
        <p>Write an anonymous review on how the deal went</p>
      </div>
    </div>
  );
}
